export default __webpack_public_path__ + "static/media/Rwanda.c9f9d960.png";